import React, { useState } from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import { getNumberInputParameters } from 'modules/questionnaire/helpers';
import { useNumberInputValidation } from 'modules/questionnaire/useNumberInputValidation';
import { adjustTranslationKey } from '../helpers';
import { CheckEligibility } from './CheckEligibility';
import { questionPropTypes } from './questionPropTypes';

export const BoxNumberQuestion = ({ q, user, onselect }) => {
  const [value, setValue] = useState(q.getQuestionValue ? q.getQuestionValue(user) : (user?.condition_profile[q.id] || ''));
  const { t } = useTranslation();
  const {
    unit, step, max, min,
  } = getNumberInputParameters(q.numberType);

  const validate = useNumberInputValidation({ max, min });

  const handleChange = (event) => {
    const { target: { value: nextValue } } = event;
    if (validate(nextValue).isValid) {
      setValue(nextValue);
      onselect(nextValue);
    }
  };

  return (
    <div className="hcp-input">
      <div className="hcp-input-title space-between">
        <div>
          {t(adjustTranslationKey(q.title))}
        </div>
        <div className="hcp-number-unit">{unit}</div>
      </div>
      <CheckEligibility />
      <input
        className="hcp-number-input"
        type="number"
        step={step}
        value={value}
        onChange={handleChange}
      />
    </div>
  );
};

BoxNumberQuestion.propTypes = questionPropTypes;
